import { render, staticRenderFns } from "./ItemDropdown.vue?vue&type=template&id=58847cee&"
import script from "./ItemDropdown.vue?vue&type=script&lang=js&"
export * from "./ItemDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports